import React from "react";
import images from "../../../../../utilities/images/images";
import useAppHooks from "../../../../../shared/hooks/useAppHooks";
import { useSelector } from "react-redux";
import "./GoToAdvAnalytics1.scss";
import { resolveAttemptId } from "../../../utils/resolveAttemptId";

const GoToAdvAnalytics1 = () => {
  const { history } = useAppHooks();
  const { basicAnalytics, selectedAttemptId } = useSelector(
    (state) => state.analyticsSlice
  );

  const goToAnalytics = () => {
    const attemptCount = resolveAttemptId(
      selectedAttemptId ?? basicAnalytics?.data?.selected_attempt,
      basicAnalytics?.data?.attempts || []
    );
    history.push("/adv-analytics", { attempt_count: attemptCount });
  };

  return (
    <div className="goToAdvAnalytics1" onClick={goToAnalytics}>
      {" "}
      <img src={images.analytics} alt="icon" />
      Advanced Analytics
    </div>
  );
};

export default GoToAdvAnalytics1;
